import { ElMessage } from 'element-plus'

export const improvingNoticeOptions = {
  message: '完善中…',
  duration: 1500,
  grouping: true,
  showClose: false,
  customClass: 'improving-notice'
} as const

export const showImproving = () => ElMessage(improvingNoticeOptions)
